import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { FapService } from '@api/backend';
import { catchError, map, of, switchMap } from 'rxjs';
import { ErrorResponse } from '@core/models';
import { searchActions } from '@app2/store/search/search.actions';



@Injectable()
export class SearchEffects {

  public loadFaps = createEffect(() => {
    return this.actions$.pipe(
      ofType(searchActions.loadFaps),
      switchMap(({ p, ps, q }) => this.fapService.getFapListFapGet(
        undefined,
        undefined,
        undefined,
        q,
        undefined,
        undefined,
        undefined,
        p,
        ps,
      ).pipe(
        map(({ data }) => searchActions.loadFapsSuccess({ data })),
        catchError((error: unknown) => of(searchActions.loadFapsFailure({ error: error as ErrorResponse }))),
      )),
    );
  });

  constructor(
    private actions$: Actions,
    private fapService: FapService,
  ) {}
}
